export default "__VITE_ASSET__xamdg_Cr__"